import { Link } from 'react-router-dom';
import { categories } from '@/mocks/tv-shows';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-xl text-white"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white">
                老子影视网
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-5">
              老子影视网电视剧大全全集播放，涵盖国产剧全集、韩剧全集、最新电视剧免费在线观看，高清画质不缓冲，追剧必备。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-all duration-200 cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-all duration-200 cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-all duration-200 cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white mb-4">
              电视剧分类
            </h4>
            <ul className="space-y-2.5">
              {categories.filter(c => c.slug !== 'all').map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white mb-4">
              热门推荐
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/guochan" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">庆余年第二季</Link></li>
              <li><Link to="/category/guochan" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">狂飙</Link></li>
              <li><Link to="/category/hanju" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">背着善宰跑</Link></li>
              <li><Link to="/category/guochan" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">繁花</Link></li>
              <li><Link to="/category/hanju" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">眼泪女王</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white mb-4">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">联系方式</Link></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; {currentYear} 老子影视网 laoziys.com All Rights Reserved.
          </p>
          <p className="text-xs text-foreground-600">
            本站所有内容均来自网络，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}